// Select nativo HTML — accesible por default, mobile-friendly (en touch abre
// el picker nativo del OS). No usamos Radix Select para no agregar deps.

import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  function Select({ className, children, ...props }, ref) {
    return (
      <select
        ref={ref}
        className={cn(
          'flex h-10 w-full rounded border border-border bg-surface-input px-3 py-2 text-sm text-fg',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:border-accent',
          'disabled:cursor-not-allowed disabled:opacity-50 disabled:text-fg-disabled',
          'aria-invalid:border-crit aria-invalid:ring-crit',
          className,
        )}
        {...props}
      >
        {children}
      </select>
    );
  },
);
